import api from '../api';
import sanitizeFilename from 'sanitize-filename';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';
import { ItemTypes } from '../../constants/constants';
import { getFileExtension, getFileNameWithoutExtension } from '../../../../shared/utils/files/file-upload-accepts';

const label = 'rename';

function handler(apiOptions, actions) {
  const { showDialog, hideDialog, navigateToDir, setParentsForResource, getSelectedResources, getResource, rootContainer } = actions;

  const getMessage = getMess.bind(null, apiOptions.locale);
  const localeLabel = getMessage(label);
  const selectedElement = getSelectedResources()[0];

  const rawDialogElement = {
    elementType: 'RenameDialog',
    elementProps: {
      initialValue: getFileNameWithoutExtension(selectedElement.name),
      extension: selectedElement.type !== ItemTypes.Directory ? getFileExtension(selectedElement.name) : '',
      resourceType: selectedElement.type,
      onHide: hideDialog,
      rootContainer: rootContainer,
      beforeSubmit: async (newName) => {
        const sinitizedName = sanitizeFilename(newName);

        return await api.getFilesInDestinationFolder(apiOptions, [sinitizedName], selectedElement.parentId, [selectedElement.id]);
      },
      onSubmit: async (name) => {
        const sinitizedName = sanitizeFilename(name);

        return await api.renameResource(apiOptions, selectedElement.id, sinitizedName, selectedElement.parentId);
      },
      afterSubmit: async () => {
        hideDialog();
        navigateToDir(selectedElement.parentId, selectedElement.id);
        setParentsForResource(selectedElement.parentId);
      },
    },
  };
  showDialog(rawDialogElement);
}

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);
  const { getSelectedResources } = actions;
  return {
    id: label,
    icon: { icon: icons.rename },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const selectedResources = getSelectedResources();

      return selectedResources.length === 1 && selectedResources.every((r) => r.capabilities.canRename);
    },
    availableInContexts: ['row', 'toolbar'],
    handler: () => handler(apiOptions, actions),
  };
};
